import { RouteStatus } from '../enums';

export type RouteStatusColorMap = Record<
  RouteStatus,
  { backgroundColor: string; ballColor: string; textColor: string }
>;

export const STATUS_COLORS: RouteStatusColorMap = {
  [RouteStatus.CREATED]: {
    backgroundColor: '#E8F5E9',
    ballColor: '#2E7D32',
    textColor: '#2E7D32',
  },
  [RouteStatus.ASSIGNED]: {
    backgroundColor: '#E8F5E9',
    ballColor: '#2E7D32',
    textColor: '#2E7D32',
  },
  [RouteStatus.ACTIVE]: {
    backgroundColor: '#E1F5FE',
    ballColor: '#0288D1',
    textColor: '#0288D1',
  },
  [RouteStatus.STARTED]: {
    backgroundColor: '#FFFDE7',
    ballColor: '#F9A825',
    textColor: '#F57F17',
  },
  [RouteStatus.IN_PROGRESS]: {
    backgroundColor: '#E3F2FD',
    ballColor: '#1976D2',
    textColor: '#1976D2',
  },
  [RouteStatus.COMPLETED]: {
    backgroundColor: '#E8F5E9',
    ballColor: '#2E7D32',
    textColor: '#2E7D32',
  },
  [RouteStatus.CANCELLED]: {
    backgroundColor: '#FFEBEE',
    ballColor: '#C62828',
    textColor: '#C62828',
  },
  [RouteStatus.PAUSED]: {
    backgroundColor: '#FFF3E0',
    ballColor: '#F57C00',
    textColor: '#F57C00',
  },
  [RouteStatus.PENDING_DRIVER_CONFIRMATION]: {
    backgroundColor: '#FFF8E1',
    ballColor: '#F9A825',
    textColor: '#F9A825',
  },
  [RouteStatus.PENDING_HERMES_ASSIGN]: {
    backgroundColor: '#F3E5F5',
    ballColor: '#8E24AA',
    textColor: '#8E24AA',
  },
  [RouteStatus.CLOSED]: {
    backgroundColor: '#FFEBEE',
    ballColor: '#C62828',
    textColor: '#C62828',
  },
};
